const columns = [
  {
    title: '入口分类',
    links: [
      { id: 'entry', label: '入口总览' },
      { id: 'directory', label: '网址大全' },
      { id: 'permanent', label: '永久入口' },
    ],
  },
  {
    title: '使用帮助',
    links: [
      { id: 'latest', label: '最新地址更新记录' },
      { id: 'access', label: '首页入口访问步骤' },
      { id: 'verify', label: '辨别官方网址' },
    ],
  },
  {
    title: '安全相关',
    links: [
      { id: 'safety', label: '安全浏览提示' },
      { id: 'faq', label: '常见问题' },
      { id: 'top', label: '返回顶部' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-secondary-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">星辰影院</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              汇聚星辰影院相关的官网入口、最新地址、网址大全与永久入口信息，帮助用户更快定位合适的访问方式。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-secondary-400">
              本站为入口与地址整理页，仅提供信息导航，具体内容以官方页面为准。
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title} className="lg:col-span-1">
              <h3 className="text-sm font-semibold text-background-50">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={`#${l.id}`}
                      className="inline-flex items-center gap-1.5 text-sm text-secondary-300 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-right-s-line text-primary-400"></i>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">© 2026 星辰影院入口导航 · 内容仅供参考</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-secondary-400">
            <a href="#safety" className="hover:text-primary-300 transition-colors cursor-pointer">安全提示</a>
            <a href="#faq" className="hover:text-primary-300 transition-colors cursor-pointer">常见问题</a>
            <a href="#top" className="hover:text-primary-300 transition-colors cursor-pointer">返回顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}